<template #default>

    <div class="comments-container" v-if="ready" :class=" reactionsOnly ? 'reactions-only' : 'full' ">

        <div class="pre-comments-section inner-wrapper" v-if=" 'jeunes' === audienceMode ">
            <Reactions
                :postType="mainPostType"
                :postId="mainPostId"
                :reactions="postReactions"
                :rootPostType=" mainPostType "
                :rootId=" mainPostId "
                :commentParentId="0"
                :canContract="false"
            ></Reactions>

        </div>

        <div class="comment-main-form" v-if="!reactionsOnly">
            <div class="top-level-comment-form">
                <div class="avatar-container">
                    <Avatar :user="getCurrentUserForAvatar"></Avatar>
                </div>
                <comment-form
                    :formOpenClass="formOpenClass"
                    :commentData="{}"
                    :postType="mainPostType"
                    :postId="mainPostId"
                    :key=" 'top-comment-form' "
                    :placeholder="topLevelFormPlaceholder"
                    :rootPostType=" mainPostType "
                    :rootId=" mainPostId "
                ></comment-form>

            </div>

            <div class="toggle-comments-container" v-if="!reactionsOnly">
                <button class="btn btn-toggle-comments-section"
                        v-html="getCommentToggleBtnText"
                        @click="toggleComments"
                ></button>
            </div>

            <div class="individual-comments-container" v-if="store.state.showComments">
                <comment v-for="( comment, index ) in comments || []"
                         v-if="comments.length > 0"
                         :key="comment.id"
                         :key-id="comment.id + '_' + index"
                         :commentData="comment"
                         :topLevelComment="true"
                         :postType="mainPostType"
                         :postId="mainPostType"
                         :commentLevel="1"
                         :rootPostType=" mainPostType "
                         :rootId=" mainPostId "
                ></comment>
            </div>

        </div>


    </div>

    <div class="loading-container" v-if="!ready"><span class="ajax-loader on-the-left"></span> {{ loadingText }}</div>

    <ReportComment v-if="ready"></ReportComment>
</template>

<script>
export default {
    name       : 'Comments Module',
    components : [ CommentForm, Comment, Avatar, Reactions ],
}
</script>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount, reactive, inject, getCurrentInstance } from "vue";
import { useStore }                                                       from "vuex";
import { uniqueId }                                                       from 'lodash-es';
import { isSessionLoggedIn }                                              from '../composables';
import { getCsrfCookie }                                                  from '../../Utils';

// components
import Comment       from "./Comment.vue";
import CommentForm   from './CommentForm.vue';
import Avatar        from './Avatar.vue';
import Reactions     from "./Reactions.vue";
import ReportComment from "./ReportComment.vue";


let store    = useStore();
let copydeck = computed( () => store.state.copydeck );

//COMPUTED
let ready = computed( () => store.state.ready );

const mainPostType         = inject( 'commentsPostType' );
const mainPostId           = inject( 'commentsPostId' );
const reactionsOnly        = inject( 'reactionsOnly' );
const startClosed          = inject( 'startClosed' );
const loadingText          = inject( 'loadingText' );
const audienceMode         = inject( 'audienceMode' );
const doLiveRefresh        = inject( 'doLiveRefresh' );
const liveRefreshFrequency = inject( 'liveRefreshFrequency' );
const mixDate = inject( 'mixDate' );

const comments = computed( () => store.getters.comments );

let commentsRefreshTimeout;
let isUpdatingComments;

let formOpenClass = ' form-open ';


const getCurrentUserForAvatar = computed( () =>
{

    if ( store.getters.currentUser )
    {
        return store.getters.currentUser;
    }


    return null;

} );


let topLevelFormPlaceholder = computed( () =>
{


    if ( store.getters.comments.length > 0 )
    {
        return copydeck?.value?.formPlaceholderWhenHasComments?.fr ?? 'BLA';
    }

    return copydeck?.value?.formPlaceholderWhenNoComments?.fr ?? 'BLA';


} );

const getCommentToggleBtnText = computed( () =>
{

    // currently shown -> can only be closed
    if ( store.state.showComments )
    {
        return copydeck?.value?.btnCloseComments?.fr ?? 'Fermer';

    }




    // 0 / no comments
    if ( commentsFullCount.value < 1 )
    {
        return copydeck?.value?.btnOpenComments?.fr ?? 'Ouvrir';
    }

    // ONE comment exactly
    if ( commentsFullCount.value === 1 )
    {
        return copydeck?.value?.btnOpenCommentsSingular?.fr ?? 'Ouvrir';
    }


    // > 1 comments
    return (copydeck?.value?.btnOpenCommentsPlural?.fr ?? 'Lire les commentaires').replace( '%d', commentsFullCount.value );


} );

let commentsFullCount = computed( () =>
{

    let fullTotal = 0;

    if ( comments.value.length > 0 )
    {
        comments.value.forEach( comment =>
        {

            fullTotal++;

            if ( typeof comment.child_comments !== 'undefined' && comment.child_comments.length > 0 )
            {
                fullTotal += comment.child_comments.length;
            }


        } )
    }


    return fullTotal;

} )

let postReactions = computed( () =>
{
    return store.getters.mainPostReactions;
} );

//methods
async function mounted ()
{

    store.commit( "initialCommentsState", !startClosed );
    store.commit( "changeAudienceMode", audienceMode );

    store.commit( "setLiveRefreshMode", parseInt( doLiveRefresh ) === 1 || doLiveRefresh === true );
    store.commit( "setLiveRefreshModeFrequency", parseInt( liveRefreshFrequency ) );

    // console.log( ' store.state.showComments = !startClosed', store.state.showComments, startClosed );

    // console.log( 'MOUNTED', {
    //     mainContentType : mainPostType,
    //     mainContentId   : mainPostId,
    //     reactionsOnly   : reactionsOnly,
    //     audienceMode    : audienceMode,
    // } )


    store.dispatch( "mainContentInfo", {
        mainContentType : mainPostType,
        mainContentId   : mainPostId,
        reactionsOnly   : reactionsOnly,
    } )


    await store.dispatch( "copydeck" );
    await store.dispatch( "updateRelatedDataInStore" );
    await store.dispatch( "updateUserReactions" );


    await initialSetup();

    store.commit( "ready" );

}


function toggleComments ()
{
    store.commit( "toggleComments" );
}

async function initialSetup ()
{

    // console.log( 'initialSetup()' );

    // try
    // {

    // console.log( 'Getting CSRF Cookie' );
    const getCsrfCookieResult = getCsrfCookie();
    // console.log( 'Got CSRF Cookie' );


    // console.log( 'Checking if logged-in' );
    const isLoggedInResult = isSessionLoggedIn( store );
    // console.log( 'Checked if logged-in' );


    // }
    // catch (err)
    // {
    //
    // }


    if ( store.state.doLiveRefresh )
    {
        startRefreshComments();
    }

}

onMounted( mounted );
onBeforeUnmount( () => clearTimeout( commentsRefreshTimeout ) );


function getDefaultAvatarUrl ()
{

    // console.log("DOES IT EXIST?", copydeck, copydeck.value.avatars)

    if ( typeof copydeck.value.avatars === 'undefined' )
    {
        return '';
    }

    const defaultId = parseInt( copydeck?.value?.defaultAvatarId?.fr ?? 0 );


    const defaultAvatar = copydeck.value.avatars.find( av => av.id === defaultId );
    // console.log( 'defaultAvatar', defaultAvatar, defaultId );

    if ( !defaultAvatar )
    {
        return '';
    }

    return defaultAvatar.profileSizeUrl;
}

function getDefaultAvatarFrameUrl ()
{

    if ( typeof copydeck.value.avatarFrames === 'undefined' )
    {
        return '';
    }

    const defaultId = parseInt( copydeck?.value?.defaultFrameId?.fr ?? 0 );

    const defaultFrame = copydeck.value.avatarFrames.find( avf => avf.id === defaultId );

    // console.log( 'defaultFrame', defaultFrame );
    if ( !defaultFrame )
    {
        return '';
    }

    return defaultFrame.url;
}


async function startRefreshComments ()
{
    //addEventListener( 'focus', setUpdatingComments );
    //addEventListener( 'blur', stopUpdatingComments );

    scheduleCommentsRefresh();
}


async function setLiveCommentsRefresh ()
{
    if ( store.state.doLiveRefresh )
    {
        await refreshComments();
    }
}

function scheduleCommentsRefresh ()
{
    clearTimeout( commentsRefreshTimeout );

    const frequency = Math.max( parseInt( store.state.liveRefreshFrequency ) || 30, 5 );
    commentsRefreshTimeout = setTimeout( setLiveCommentsRefresh, frequency * 1000 );
}

async function refreshComments ()
{
    if ( !store.getters.isCurrentlyUpdatingComments )
    {
        await store.dispatch( "updateRelatedDataInStore" );
    }

    scheduleCommentsRefresh();
}

async function setUpdatingComments2 ()
{
    clearTimeout( commentsRefreshTimeout );

    console.log( 'Window is active. Setting new comments refresh timeout.... ' + (store.state.liveRefreshFrequency) + ' seconds' );
    commentsRefreshTimeout = setTimeout( async () =>
    {

        // no use in doubling the update

        if ( !store.getters.isCurrentlyUpdatingComments )
        {
            let updating = await store.dispatch( "updateRelatedDataInStore" );
        }

        setUpdatingComments();

    }, store.state.liveRefreshFrequency * 1000 );
}


async function stopUpdatingComments ()
{
    //clearTimeout( commentsRefreshTimeout );

    console.log( 'Blurred Window. Stopping comments updating.' )
}


</script>


<style scoped>

</style>
